import { combineReducers } from '@reduxjs/toolkit';
import { logoutThunk } from './ducks/auth.duck';
import * as globalReducers from './ducks';
import * as pageReducers from './containers/reducers';
// CUSTOM-START: cl-cart-01
import { clearCartOnLogout } from './ducks/cart.duck';
// CUSTOM-END: cl-cart-01

/**
 * Function _createReducer_ combines global reducers (reducers that are used in
 * multiple pages) and reducers that are handling actions happening inside one page container.
 * Since we combineReducers, pageReducers will get page specific key (e.g. SearchPage)
 * which is page specific.
 * Future: this structure could take in asyncReducers, which are changed when you navigate pages.
 */
const appReducer = combineReducers({ ...globalReducers, ...pageReducers });

const createReducer = () => {
  return (state, action) => {
    // Clear state when logout is successful
    const shouldClearState = action.type === logoutThunk.fulfilled.type;
    const appState = shouldClearState ? undefined : state;

    // Clear sessionStorage when logging out.
    if (shouldClearState && typeof window !== 'undefined' && !!window.sessionStorage) {
      window.sessionStorage.clear();
    }

    // CUSTOM-START: cl-cart-01
    // D-1a: the cart lives in localStorage, which the line above does not touch, so
    // without this it survives logout and greets whoever uses the browser next. Nothing
    // is lost — a logged-in buyer's cart is mirrored on their own profile and comes back
    // on their next login.
    //
    // This is the template's own seam, not a new one: it already clears per-session
    // storage right here when logout succeeds.
    if (shouldClearState) {
      clearCartOnLogout();
    }
    // CUSTOM-END: cl-cart-01

    return appReducer(appState, action);
  };
};

export default createReducer;
